export default ({ array }, context) => {
	return {
		type: "array",
		value: array,
	};
};
